import React from 'react';
import { StatTile } from './StatTile';
import { titleize } from '../../lib/clubHelpers';

const GROUP_LABELS = {
  overall: 'Overall', offensive: 'Offensive', defensive: 'Defensive',
  passing: 'Passing', goalkeeping: 'Goalkeeping', misc: 'Miscellaneous', other: 'Other',
};
const GROUP_ORDER = ['overall', 'offensive', 'defensive', 'passing', 'goalkeeping', 'other', 'misc'];

export default function StatGrid({ details, nameMap, title }) {
  const list = Array.isArray(details) ? details : [];
  if (!list.length) {
    return <div className="stat-grid"><p className="i-dim text-sm p-4">No statistics available.</p></div>;
  }
  const groups = {};
  list.forEach((d) => {
    const g = d?.type?.stat_group || 'other';
    (groups[g] = groups[g] || []).push(d);
  });
  const order = [...GROUP_ORDER.filter((g) => groups[g]), ...Object.keys(groups).filter((g) => !GROUP_ORDER.includes(g))];
  return (
    <div className="stat-grid">
      <div className="stat-grid-head">
        <h3 className="i-fg font-semibold text-sm">{title || 'Season summary'}</h3>
        <span className="i-dim text-xs">{list.length} metrics</span>
      </div>
      {order.map((g) => (
        <section className="stat-section" key={g}>
          <div className="stat-section-h">{GROUP_LABELS[g] || titleize(g)}</div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 items-stretch">
            {groups[g].map((d, i) => <StatTile key={d?.type?.code || i} d={d} nameMap={nameMap} />)}
          </div>
        </section>
      ))}
    </div>
  );
}
